import { render, staticRenderFns } from "./AFKListener.vue?vue&type=template&id=610927e7&"
import script from "./AFKListener.vue?vue&type=script&lang=ts&"
export * from "./AFKListener.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports